import { COUNTRY_CODES, UNKNOWN_COUNTRY } from "./countries.generated";

export { UNKNOWN_COUNTRY };

const byValue = new Map<number, string>(COUNTRY_CODES);
const byCode = new Map<string, number>(COUNTRY_CODES.map(([value, code]) => [code, value]));

/** The ISO code of Core's country number, such as "GB"; empty for none. */
export function countryCode(value: number | undefined | null): string {
  return (value != null && byValue.get(value)) || "";
}

/** Core's number for an ISO code in any case; UNKNOWN_COUNTRY for anything else. */
export function countryValue(code: string | undefined | null): number {
  return (code && byCode.get(code.trim().toUpperCase())) || UNKNOWN_COUNTRY;
}

let names: Intl.DisplayNames | null | undefined;

/** The country's English name, or its code where the browser has none. */
export function countryName(code: string): string {
  if (names === undefined) {
    try {
      names = new Intl.DisplayNames(["en"], { type: "region" });
    } catch {
      names = null;
    }
  }
  return names?.of(code) ?? code;
}

/** Every country, by name, as select options valued by Core's number. */
export function countryOptions(): Array<{ title: string; value: number }> {
  return COUNTRY_CODES.map(([value, code]) => ({ title: countryName(code), value })).sort((a, b) =>
    a.title.localeCompare(b.title)
  );
}
